import { ReactNode } from "react";
import styled from "styled-components";
import { SubColor } from "../../style/styleValue";

interface SectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  tone?: "light" | "dark";
}

// 랜딩 섹션 공통 제목 (영문 라벨 + 제목 + 설명)
const SectionHeading = ({ eyebrow, title, description, align = "center", tone = "light" }: SectionHeadingProps) => {
  return (
    <Wrapper className="reveal" $align={align} $tone={tone}>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $align: "left" | "center"; $tone: "light" | "dark" }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => (props.$align === "center" ? "center" : "flex-start")};
  text-align: ${(props) => props.$align};
  max-width: ${(props) => (props.$align === "center" ? "760px" : "none")};
  margin: ${(props) => (props.$align === "center" ? "0 auto 56px" : "0 0 40px")};

  .eyebrow {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 0.8rem;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${(props) => (props.$tone === "dark" ? "#8fb6e3" : SubColor)};
    margin-bottom: 16px;

    &::before {
      content: "";
      width: 24px;
      height: 2px;
      border-radius: 2px;
      background: currentColor;
    }
  }

  h2 {
    font-size: clamp(1.6rem, 3vw, 2.3rem);
    font-weight: 700;
    line-height: 1.35;
    letter-spacing: -0.03em;
    color: ${(props) => (props.$tone === "dark" ? "#fff" : "#111")};
    margin: 0 0 16px;
    word-break: keep-all;
  }

  p {
    font-size: 1.05rem;
    line-height: 1.75;
    color: ${(props) => (props.$tone === "dark" ? "rgba(255, 255, 255, 0.72)" : "#5b6472")};
    margin: 0;
    word-break: keep-all;
  }
`;

export default SectionHeading;
